// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2FJPB","col":"styles_col__1tUNg","fulfillmentStatus":"styles_fulfillmentStatus__MzLmI","emailCol":"styles_emailCol__2_2cy"};